import { june } from "app/misc/june"
import { usePostHog } from "posthog-js/react"
import { useIntercom } from "react-use-intercom"

const useLogout = () => {
  const intercom = useIntercom()
  const posthog = usePostHog()

  return async () => {
    // Reset the june identity
    if (june) {
      june.reset()
    }

    // Reset the posthog identity
    posthog.reset()

    // Reset the intercom identity
    intercom.shutdown()
    console.log("[!] logged out intercom", intercom)

    // router.push("/api/auth/logout")
  }
}
export default useLogout
